<template>
  <main>
    <canvas id="perimetroCninos" class="canvas-h canvas-w"></canvas>
  </main>
</template>

<script>
import Chart from 'chart.js/auto';
import chartData from '../../../../../assets/datasheets/charts/perimetroCefalicoNinos.json';

export default {
  props : ['x','y'],
  methods : {
    open(){

      const labels = chartData.datapoints;
      const datasets = [];

      chartData.series.forEach(s => {
        datasets.push({
          type: 'line',
          label: s.title,
          data: s.data,
          borderColor: s.color,
          fill: false,
          tension: 0.5,
          borderWidth : 1.5,
        });
      });

      datasets.push({
        type: 'scatter',
        backgroundColor: 'rgba(75, 00, 150,1)',
        borderColor: 'rgba(75, 00, 150,1)',
        label : 'Perimetro Cefalico/Edad',
        data: [{
          "x" : Math.floor(this.x * 30),
          "y" : this.y
        }],
        options: {
          scales: {
            x: {
              type: 'linear',
              position: 'bottom'
            }
          },
        },
        elements : {
          point : {
            radius : 4
          }
        }
      });

      const data = {
        labels: labels,
        datasets: datasets
      };

      const ctx = document.getElementById('perimetroCninos').getContext('2d');

      const config = {
        data: data,
        options: {
          responsive: true,
          plugins: {
            title: {
              display: true,
              text: 'Perimetro Cefalico Niños'
            },
          },
          interaction: {
            intersect: false,
          },
          scales: {
            x: {
              display: true,
              title: {
                display: true,
                text: 'Edad'
              },
              ticks: {
                callback: function(value) {
                  if(Number(this.getLabelForValue(value)) % 30 === 0){
                      return `${this.getLabelForValue(value) / 30} M`;
                  }
                }
              },
            },
            y: {
              display: true,
              title: {
                display: true,
                text: 'Perimetro Cefalico'
              },
              suggestedMin: 25,
            }
          },
          elements : {
            point : {
              radius : 0
            }
          },
        },
      };

      new Chart(ctx, config);
    },
    export(){
      const canva = document.getElementById('perimetroCninos');
      const urlData = canva.toDataURL('image/png', 0.8);
      return {
        chart : 'Perimetro Cefalico Niños',
        imageData : urlData
      };
    }
  },
  created() {
    this.$nextTick(() => this.open());
  }
}

</script>

<style scoped>
  .canvas-h{
    height: 100%;
  }
  .canvas-w{
    width: 100%;
  }
</style>